export class BildirimEntity{
    id!: number;
    baslik!: string;
    aciklama!: string;
    okundu_mu!: boolean;
    user_id!: number;
    takip_id!:number;
    takip_durumu!:string;
    is_id!:number;
    // DEV-3350: rapor Excel bildirimi. tip 'rapor_excel' olunca tıklama takip
    // kartına değil rapor ekranındaki Excel Çıktıları sekmesine gider; indirme
    // oradan yapılır. ek_veri.durum 'hazir' | 'hata' (API yazar). silindi: süre dolup
    // dosya ve iş silinince API (DEV-3786) true yazar; bildirim kalır, listede soluk görünür.
    tip?: string;
    ek_veri?: { is_key: string; isim?: string; durum?: string; silindi?: boolean };
    rapor_excel_is_id?: number;
}